<template>
  <header class="header">
    <div class="header-left">
      <div class="logo">
        <img style="width: 220px;object-fit: contain;" src="@/views/index/assets/img/yztx.png" alt="屿智" />
      </div>
      <div class="nav-center">
        <span 
          :class="{ active: currentPage === 'home' || $route.name === 'index' }" 
          @click="goToPage('home')"
        >首页</span>
        <span 
          :class="{ active: $route.path.includes('/dashboard/profile') || $route.path.includes('/entry/loginQRCode') }" 
          @click="goToPage('ai-interview')"
        >AI面试</span>
        <span 
          :class="{ active: $route.name === 'hot-jobs' }" 
          @click="goToPage('hot-jobs')"
        >热招岗位</span>
        <span 
          :class="{ active: $route.name === 'hot-companies' }" 
          @click="goToPage('hot-companies')"
        >热门企业</span>
        <span 
          :class="{ active: false }" 
          @click="goToPage('career-planning')"
        >职业规划</span>
        <span 
          :class="{ active: $route.path.includes('/qzpp') }" 
          @click="goToPage('job-coaching')"
        >求职陪跑</span>
      </div>
    </div>

    <div class="nav-buttons">
      <div class="header-content">
        <div class="switch-box">
          <button :class="['switch-btn', { active: activeSide === 'hire' }]" @click="handleSwitch('hire')">
            我要招聘
          </button>
          <button :class="['switch-btn', { active: activeSide === 'seek' }]" @click="handleSwitch('seek')">
            我要求职
          </button>
        </div>

        <div class="header-links" v-if="isLoggedIn">
          <span class="header-link" :class="{ active: $route.name === 'chating' }"  @click="goToMessages">消息</span>
          <span class="header-link" :class="{ active: $route.name === 'interview_mianshilishi' || $route.path.includes('/interview_mianshilishi') }" @click="goToInterviewHistory">面试记录</span>
        </div>

        <div class="user-section">
          <template v-if="isLoggedIn">
            <div class="user-info" @click="toggleUserMenu" v-click-outside="closeUserMenu">
              <div class="avatar-container">
                <img :src="finalAvatar" class="avatar" />
              </div>
              <span class="text">{{ userNickname ? `Hi, ${userNickname}!` : 'Hi, 请登录' }}</span>

              <transition name="fade">
                <div v-if="showUserMenu" class="user-dropdown-menu">
                  <div class="menu-item" @click="goToProfile">
                    <img class="icon-left" src="@/components/PageHeader/assets/img/ic-user.png" alt="" />
                    <span class="txt">个人中心</span>
                  </div>
                  <div class="menu-item" @click="goToResumeManage">
                    <img class="icon-left" src="@/components/PageHeader/assets/img/ic-resume.png" alt="" />
                    <span class="txt">简历管理</span>
                  </div>
                  <div class="menu-item" @click="goToOpportunity">
                    <img class="icon-left" src="@/components/PageHeader/assets/img/ic-opportunity.png"
                      alt="" />
                    <span class="txt">求职陪跑</span>
                  </div>
                  <div class="menu-item" @click="goToFeedback">
                    <img class="icon-left" src="@/components/PageHeader/assets/img/ic-yjfk.png" alt="" />
                    <span class="txt">意见反馈</span>
                  </div>
                  <div class="menu-divider"></div>
                  <div class="menu-item" @click="logout">
                    <i class="el-icon-switch-button"></i>
                    <span>退出登录</span>
                  </div>
                </div>
              </transition>
            </div>
          </template>

          <template v-else>
            <template v-if="activeSide === 'seek'">
              <router-link to="/store/entry/loginQRCode" tag="button" class="btn btn-primary">
                登录
              </router-link>
            </template>
            <template v-else-if="activeSide === 'hire'">
              <button class="btn btn-primary">
                登录
              </button>
            </template>
          </template>
        </div>
      </div>
    </div>
    <!-- 意见反馈弹窗 -->
    <FeedbackDialog 
      :visible="feedbackDialogVisible" 
      :question="question" 
      @cancel="cancelFeedback" 
      @submit="handleFeedbackSubmit" 
    />
  </header>
</template>

<script>
import { logout as logoutApi, getUserInfo } from '@/api/user'
import { submitFeedback } from '@/api/user'
import { DEFAULT_AVATAR } from '@/constants/avatar'
import { getToken } from '@/store/local/auth'
import FeedbackDialog from '@/components/FeedbackDialog/index.vue'

export default {
  components: {
    FeedbackDialog
  },
  props: {
    currentPage: {
      type: String,
      default: 'home'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    activeSide: {
      type: String,
      default: 'seek'
    }
  },
  data() {
    return {
      showUserMenu: false,
      feedbackDialogVisible: false,
      question: '您对我们的服务有什么建议吗？',
      userAvatar: '',
      userNickname: '',
      DEFAULT_AVATAR
    }
  },
  computed: {
    // 判断是否登录
    isLoggedIn() {
      return !!getToken()
    },
    finalAvatar() {
      if (!this.avatar) {
        return DEFAULT_AVATAR
      }
      if (this.avatar.includes('https')) {
        return this.avatar
      }
      return DEFAULT_AVATAR
    }
  },
  async mounted() {
    await this.loadUserInfo()
  },
  watch: {
    // 监听路由变化，重新加载用户信息
    '$route'() {
      this.loadUserInfo()
    }
  },
  directives: {
    'click-outside': {
      bind(el, binding) {
        el.clickOutside = (e) => {
          if (!el.contains(e.target)) binding.value()
        }
        document.addEventListener('click', el.clickOutside)
      },
      unbind(el) {
        document.removeEventListener('click', el.clickOutside)
      }
    }
  },
  methods: {
    goToPage(page) {
      switch (page) {
        case 'home':
          if (this.$route.name !== 'index') {
            this.$router.push({ name: 'index' })
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
          break
        case 'ai-interview':
          this.$store.commit('interviewState/CLEAR_CURRENT_INTERVIEW_JOB')
          if (this.isLoggedIn) {
            this.$router.push('/store/dashboard/profile')
          } else {
            this.$router.push('/store/entry/loginQRCode')
          }
          break
        case 'hot-jobs':
          if (this.$route.name !== 'hot-jobs') {
            this.$router.push({ name: 'hot-jobs' })
          }
          break
        case 'job-coaching':
          this.$router.push('/qzpp')
          break
        case 'hot-companies':
        case 'popular-companies':
          if (this.$route.name !== 'hot-companies') {
            this.$router.push({ name: 'hot-companies' })
          }
          break
        case 'career-planning':
        this.$router.push('/mbti-selection')
          break
        default:
          break
      }
    },
    handleSwitch(side) {
      if (side === 'hire') {
        window.location.href = 'https://business.yuugeai.com/'
      }
      this.$emit('switch-side', side)
    },
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu
    },
    closeUserMenu() {
      this.showUserMenu = false
    },
    async logout() {
      try {
        await logoutApi()
      } catch (error) {
        console.error('退出登录失败:', error)
      }
      this.$store.dispatch('user/logout')
      this.$router.push('/store/entry/loginQRCode')
      this.closeUserMenu()
    },
    // 加载用户信息
    async loadUserInfo() {
      if (!this.isLoggedIn) {
        this.userAvatar = ''
        this.userNickname = ''
        return
      }
      try {
        const res = await getUserInfo()
        if (res.data.code === 1) {
          this.userNickname =res.data.data.real_name ||res.data.data.nickname || ''
          this.userAvatar = res.data.data.avatar || ''
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    },
    goToProfile() {
      this.$router.push('/store/personal/basic')
      this.closeUserMenu()
    },
    goToMessages() {
      this.$router.push('/chating')
      this.closeUserMenu()
    },
    goToInterviewHistory() {
      this.$router.push('/interview_mianshilishi')
      this.closeUserMenu()
    },
    goToResumeManage() {
      this.$router.push('/store/personal/resume')
      this.closeUserMenu()
    },
    goToOpportunity() {
      this.$router.push('/qzpp')
      this.closeUserMenu()
    },
    goToFeedback() {
      this.feedbackDialogVisible = true
      this.closeUserMenu()
    },
    cancelFeedback() {
      this.feedbackDialogVisible = false
    },
    async handleFeedbackSubmit(data) {
      const content = data.feedbackText ? data.feedbackText.trim() : ''
      if (!content) {
        this.$message.warning('请输入反馈内容')
        return
      }
      try {
        await submitFeedback({
          emojiIndex: data.emojiIndex,
          feedbackText: content
        })
        this.$message.success('反馈提交成功')
        this.feedbackDialogVisible = false
      } catch (error) {
        console.error('提交反馈失败:', error)
        this.$message.error('提交反馈失败，请稍后重试')
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(4px);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  min-height: 64px;
  padding-left: 24px;
  padding-right: 24px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 0;
}

.logo {
  display: flex;
  align-items: center;
  height: 64px;
}

  .nav-center {
    display: flex;
    font-size: 17px;
    justify-content: flex-start;
    align-items: center;
    gap: 40px;
    height: 64px;
    margin-left: 32px;

  span {
    cursor: pointer;
    color: #656587;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0 8px;
    white-space: nowrap;
    position: relative;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;

    &:hover {
      background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    
    &.active {
      background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}

.active {
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.nav-buttons {
  display: flex;
  gap: 10px;
}

.btn {
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.btn-primary {
  background: var(--linear-2-paints, linear-gradient(90deg, rgba(126, 180, 235, 1) 0%, rgba(177, 110, 249, 1) 100%));
  border-radius: 24px;
  color: white;
  border: none;
  width: 80px;
  height: 44px;
}

.switch-box {
  display: flex;
  align-items: center;
  height: 36px;
  width: 170px;
  gap: 8px;
  padding: 4px 10px 4px 6px;
  border-radius: 999px;
  border: 1px solid transparent;
  background: linear-gradient(#fff, #fff) padding-box,
    linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%) border-box;
  box-shadow: 0 2px 8px rgba(124, 142, 255, 0.25);
}

.switch-btn {
  padding: 6px 12px;
  border: none;
  background: #f5f5f5;
  color: #656587;
  -webkit-text-fill-color: #656587;
  background-clip: initial;
  -webkit-background-clip: initial;
  font-size: 13px;
  font-weight: 500;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  height: 28px;
  display: flex;
  align-items: center;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  min-width: 44px;
}

.switch-btn:hover {
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%),
    linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  color: #fff;
  border-color: transparent;
}

.switch-btn.active {
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%),
    linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  color: #fff;
  -webkit-text-fill-color: #fff;
  border-color: transparent;
  box-shadow: none;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  gap: 24px;
}

.header-links {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-link {
  font-size: 16px;
  color: #656587;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  
  &:hover {
    background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  
  &.active {
    background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

.user-section {
  display: flex;
  align-items: center;
  height: 36px;
}

.user-info {
  position: relative;
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 4px;
  height: 36px;
  padding: 0 10px 0 4px;
  background: rgba(255, 255, 255, 0.4);
  border: 1px solid #e5e5e5;
  border-radius: 18px;
  box-shadow: 0 2px 9px rgba(0, 0, 0, .08);
  cursor: pointer;
  transition: all .16s ease;
}

.user-info:hover {
  border-color: #0071e3;
  box-shadow: 0 4.8px 19.2px rgba(0, 113, 227, .25);
}

.avatar-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
}

.text {
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1f;
}

.user-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: #F9F9FB;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  min-width: 160px;
  z-index: 1001;
  margin-top: 6px;
  max-height: 400px;
  overflow-y: auto;
}

.user-dropdown-menu::before {
  content: '';
  position: absolute;
  top: -6px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #e4e7ed;
}

.user-dropdown-menu::after {
  content: '';
  position: absolute;
  top: -5px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #F9F9FB;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-size: 13px;
  color: #333;
}

.menu-item:hover .txt {
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.menu-item:hover .icon-left {
  filter: hue-rotate(200deg) saturate(1.5) brightness(1.2);
}

.menu-item:hover i {
  color: #77BAFF;
}

.menu-item i {
  font-size: 16px;
  color: #666;
}

.menu-item:first-child {
  border-radius: 10px 10px 0 0;
}

.menu-item:last-child {
  border-radius: 0 0 10px 10px;
}

.menu-divider {
  height: 1px;
  background-color: #e4e7ed;
  margin: 4px 0;
}

.icon-left {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.txt {
  flex: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .16s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 1200px) {
  .header {
    padding-left: 16px;
    padding-right: 16px;
  }

  .nav-center {
    gap: 24px;
    margin-left: 20px;
    font-size: 15px;
  }

  .header-links {
    gap: 16px;
  }

  .header-link {
    font-size: 14px;
  }
}

@media (max-width: 968px) {
  .nav-center {
    gap: 16px;
    margin-left: 16px;
    font-size: 14px;
    
    span {
      padding: 0 4px;
    }
  }

  .logo img {
    width: 180px !important;
  }

  .header-links {
    gap: 12px;
  }

  .header-link {
    font-size: 13px;
  }

  .switch-box {
    width: 150px;
  }

  .switch-btn {
    font-size: 12px;
    padding: 6px 10px;
  }
}

@media (max-width: 768px) {
  .header {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 16px;
    min-height: auto;
  }

  .header-left {
    width: 100%;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    height: auto;
    flex-shrink: 0;
    
    img {
      width: 140px !important;
    }
  }

  .nav-center {
    width: 100%;
    margin-left: 0;
    gap: 8px;
    font-size: 13px;
    flex-wrap: wrap;
    height: auto;
    margin-top: 8px;
    justify-content: flex-start;
    
    span {
      padding: 6px 10px;
      height: auto;
      font-size: 13px;
      min-height: 32px;
      display: flex;
      align-items: center;
      border-radius: 4px;
    }
  }

  .nav-buttons {
    width: 100%;
    margin-top: 12px;
  }

  .header-content {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    flex-wrap: wrap;
  }

  .switch-box {
    width: auto;
    min-width: 140px;
    flex-shrink: 0;
  }

  .header-links {
    display: none; // 移动端隐藏消息和面试记录链接，因为可以在用户菜单中找到
  }

  .header-link {
    font-size: 14px;
  }

  .user-section {
    flex-shrink: 0;
  }

  .user-info {
    padding: 0 8px 0 4px;
    
    .text {
      font-size: 12px;
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .user-dropdown-menu {
    right: 0;
    left: auto;
    min-width: 180px;
    max-width: calc(100vw - 32px);
  }

  .btn-primary {
    width: 70px;
    height: 40px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .header {
    padding: 10px 12px;
  }

  .logo img {
    width: 120px !important;
  }

  .nav-center {
    gap: 6px;
    font-size: 12px;
    margin-top: 6px;
    
    span {
      padding: 5px 8px;
      font-size: 12px;
      min-height: 28px;
    }
  }

  .header-content {
    align-items: stretch;
    gap: 10px;
  }

  .switch-box {
    max-width: 100%;
  }

  .switch-btn {
    font-size: 12px;
    padding: 6px 10px;
    flex: 1;
  }

  .user-info {
    justify-content: center;
    
    .text {
      max-width: none;
    }
  }

  .user-dropdown-menu {
    right: 0;
    left: 0;
    width: calc(100vw - 24px);
    max-width: none;
  }

  .btn-primary {
    width: 100%;
    max-width: 200px;
    height: 40px;
    font-size: 14px;
  }
}
</style>
